import React from 'react'
import EqPublicEventList from '../eqPublicEventList/EqPublicEventList'

const EqPublicEventListPage = () => {
  return (
    <div className='eq-container-fluid'><EqPublicEventList/></div>
  )
}

export default EqPublicEventListPage